export const ATL_NUMBER = '+14043838508'
export const STL_NUMBER = '+13146652324'

export const PHONE_NUMBERS_BY_REGION = {
  'atlanta-ga': ATL_NUMBER,
  'st-louis-mo': STL_NUMBER
}
